import Accordion from '@eversports/react-components/primitives/Accordion'
import { makeStyles } from '@mui/styles'
import React, { useRef } from 'react'

interface Props {
  isExpanded?: boolean
  children: Array<React.ReactNode>
}

const useStyles = makeStyles({
  root: {
    maxWidth: 575,
  },
})

const PaymentMethodExpansionPanel: React.FC<React.PropsWithChildren<Props>> = ({ isExpanded, children }) => {
  const classes = useStyles()
  const ref = useRef<HTMLElementTagNameMap['div']>(null)

  const scrollIntoView = () => {
    if (!ref.current) return
    ref.current.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <Accordion
      ref={ref}
      defaultExpanded={isExpanded}
      className={classes.root}
      TransitionProps={{ onEntered: scrollIntoView }}
    >
      {children}
    </Accordion>
  )
}

PaymentMethodExpansionPanel.defaultProps = {
  isExpanded: true,
}

export default PaymentMethodExpansionPanel
